import { VerificationCodeResponse } from "@core/types";
import { useGetSmsCode, useGetUcallerCode } from "../../../../providers/Auth";
import { VerificationMethod } from "../types";

type RequestVerificationCallbacks = {
  onError?: (error: unknown) => void;
  onSuccess: (data: VerificationCodeResponse, method: VerificationMethod) => void;
};

export const useRequestCallWithSmsFallback = () => {
  const { mutate: getSmsCode, isPending: isSmsPending, isError, reset } = useGetSmsCode();
  const { mutate: getUcallerCode, isPending: isCallPending } = useGetUcallerCode();

  const requestVerification = (phone: string, callbacks: RequestVerificationCallbacks) => {
    reset();

    getUcallerCode(
      { phone },
      {
        onSuccess: (data) => callbacks.onSuccess(data, "call"),
        onError: () => {
          getSmsCode(
            { phone },
            {
              onSuccess: (data) => callbacks.onSuccess(data, "sms"),
              onError: (error) => callbacks.onError?.(error),
            },
          );
        },
      },
    );
  };

  return {
    requestVerification,
    isPending: isCallPending || isSmsPending,
    isError,
  };
};
